import { ModuleWithProviders, NgModule } from '@angular/core';
import { THEME_TOKEN, Theme } from './types/theme.types';

@NgModule()
export class CoreModule {
  static forRoot(theme: Theme): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [{ provide: THEME_TOKEN, useValue: theme }],
    };
  }
}
